// extracted by mini-css-extract-plugin
module.exports = {"container":"PurchasedLessons_container__2MTfC","loading-container":"PurchasedLessons_loading-container__3z29p"};